import * as actionTypes from './actionTypes';

export const createIOTssidNetworkFailed = (payload) => ({
  type: actionTypes.CREATE_IOT_SSID_NETWORK_FAILED,
  payload
  });
  
  export const createIOTssidNetworkSuccess = () => ({
  type: actionTypes.CREATE_IOT_SSID_NETWORK_SUCCESS
  });

  export const createIOTssidNetwork = (info) => ({
    type: actionTypes.CREATE_IOT_SSID_NETWORK,
    info
 });

 export const resetIOTSsidErrorSuccess = () => {
  return {
    type: actionTypes.RESET_IOT_SSID_ERROR_SUCCESS
  }
}
 export const getIOTssidNetworkDetails = (wifiType) => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_DETAILS,
  wifiType
 });
 export const getIOTssidNetworkDevices = (payload) => ({
  type: actionTypes.GET_IOT_NETWORK_DEVICES,
  payload
 });

 export const getIOTssidNetworkSuccess = (payload) => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_SUCCESS,
  payload
 });

 export const getIOTssidNetworkDevicesSuccess = (payload) => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_DEVICES_SUCCESS,
  payload
 });

 export const getIOTssidNetworkFailed = (error) => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_FAILED,
  payload: error
 });

 export const getIOTssidNetworkDevicesFailed = (error) => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_DEVICES_FAILED,
  payload: error
 });

 export const getallIOTssidnetworkdetails = () => ({
  type: actionTypes.GET_ALL_IOT_SSID_NETWORK_DETAILS
 })

// Guest Network
export const getGuestNetworkSession = (masterAcct) => ({ type: actionTypes.GET_GUEST_NETWORK_SESSION, masterAcct });
export const getGuestNetworkSessionSuccess = (data) => ({ type: actionTypes.GET_GUEST_NETWORK_SESSION_SUCCESS, payload: data });
export const getGuestNetworkSessionFail = (error) => ({ type: actionTypes.GET_GUEST_NETWORK_SESSION_FAIL, payload: error });
export const updateGuestNetworkSession = (payload) => ({ type: actionTypes.UPDATE_GUEST_NETWORK_SESSION, payload });
export const updateGuestNetworkSessionSuccess = (data) => ({ type: actionTypes.UPDATE_GUEST_NETWORK_SESSION_SUCCESS, payload: data });
export const updateGuestNetworkSessionFail = (error) => ({ type: actionTypes.UPDATE_GUEST_NETWORK_SESSION_FAIL, payload: error });
export const getGuestNetworkSchedule = (masterAcct) => ({ type: actionTypes.GET_GUEST_NETWORK_SCHEDULE, masterAcct });
export const getGuestNetworkScheduleSuccess = (data) => ({ type: actionTypes.GET_GUEST_NETWORK_SCHEDULE_SUCCESS, payload: data });
export const getGuestNetworkScheduleFail = (error) => ({ type: actionTypes.GET_GUEST_NETWORK_SCHEDULE_FAIL, payload: error });
export const updateGuestNetworkSchedule = (payload) => ({ type: actionTypes.UPDATE_GUEST_NETWORK_SCHEDULE, payload });
export const updateGuestNetworkScheduleSuccess = (data) => ({ type: actionTypes.UPDATE_GUEST_NETWORK_SCHEDULE_SUCCESS, payload: data });
export const updateGuestNetworkScheduleFail = (error) => ({ type: actionTypes.UPDATE_GUEST_NETWORK_SCHEDULE_FAIL, payload: error });
export const clearGuestNetworkError = () => ({ type: actionTypes.CLEAR_GUEST_NETWORK_ERROR });
export const stopGuestSessionPolling = () => ({ type: actionTypes.STOP_GUEST_SESSION_POLLING });
export const setGuestSessionPolling = (isPolling) => ({ type: actionTypes.SET_GUEST_SESSION_POLLING, payload: isPolling });

// Networks
export const getNetworks = () => ({ type: actionTypes.GET_NETWORKS });
export const getNetworksSuccess = (data) => ({ type: actionTypes.GET_NETWORKS_SUCCESS, payload: data });
export const getNetworksFail = (error) => ({ type: actionTypes.GET_NETWORKS_FAIL, payload: error });
export const setSelectedNetwork = (network) => ({ type: actionTypes.SET_SELECTED_NETWORK, payload: network });
export const getNetworkDevices = (wifiType) => ({ type: actionTypes.GET_NETWORK_DEVICES, payload: wifiType });
export const getNetworkDevicesSuccess = (data) => ({ type: actionTypes.GET_NETWORK_DEVICES_SUCCESS, payload: data });
export const getNetworkDevicesFail = (error) => ({ type: actionTypes.GET_NETWORK_DEVICES_FAIL, payload: error });
export const updateNetwork = (payload) => ({ type: actionTypes.UPDATE_NETWORK, payload });
export const updateNetworkSuccess = (payload) => ({ type: actionTypes.UPDATE_NETWORK_SUCCESS, payload });
export const updateNetworkFail = (error) => ({ type: actionTypes.UPDATE_NETWORK_FAIL, payload: error });
export const clearUpdateNetworkError = () => ({ type: actionTypes.CLEAR_UPDATE_NETWORK_ERROR });
export const deleteNetwork = (payload) => ({ type: actionTypes.DELETE_NETWORK, payload });
export const deleteNetworkSuccess = () => ({ type: actionTypes.DELETE_NETWORK_SUCCESS });
export const deleteNetworkFail = (error) => ({ type: actionTypes.DELETE_NETWORK_FAIL, payload: error });

// Network Device Pause
export const getNetworkDevicePauseState = (macAddress) => ({ type: actionTypes.GET_NETWORK_DEVICE_PAUSE_STATE, payload: macAddress });
export const clearDevicePauseStateError = () => ({ type: actionTypes.CLEAR_DEVICE_PAUSE_STATE_ERROR });
export const clearPauseNetworkDeviceError = () => ({ type: actionTypes.CLEAR_PAUSE_NETWORK_DEVICE_ERROR });
export const getNetworkDevicePauseStateSuccess = (data) => ({ type: actionTypes.GET_NETWORK_DEVICE_PAUSE_STATE_SUCCESS, payload: data });
export const getNetworkDevicePauseStateFail = (error) => ({ type: actionTypes.GET_NETWORK_DEVICE_PAUSE_STATE_FAIL, payload: error });
export const pauseNetworkDevice = (payload) => ({ type: actionTypes.PAUSE_NETWORK_DEVICE, payload });
export const pauseNetworkDeviceSuccess = (data) => ({ type: actionTypes.PAUSE_NETWORK_DEVICE_SUCCESS, payload: data });
export const pauseNetworkDeviceFail = (error) => ({ type: actionTypes.PAUSE_NETWORK_DEVICE_FAIL, payload: error });
export const unpauseNetworkDevice = (payload) => ({ type: actionTypes.UNPAUSE_NETWORK_DEVICE, payload });
export const unpauseNetworkDeviceSuccess = (data) => ({ type: actionTypes.UNPAUSE_NETWORK_DEVICE_SUCCESS, payload: data });
export const unpauseNetworkDeviceFail = (error) => ({ type: actionTypes.UNPAUSE_NETWORK_DEVICE_FAIL, payload: error });
